import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import HomeViewold from '../views/HomeViewold.vue'
import HomeView from '../views/HomeView.vue'
import login from '../views/login/login.vue'
import newImage from '../views/newImage.vue'
Vue.use(VueRouter)

const routes = [{
	path: '/login',
	name: 'login',
	component: login,
}, {
	path: '/',
	name: 'index',
	component: index,
	children: [{
		path: '/',
		name: 'HomeView',
		component: HomeView,
	}]
}, {
	path: '/newImage',
	name: 'newImage',
	component: newImage,
}, {
	path: '/viewsO',
	name: 'HomeViewold',
	component: HomeViewold,
}]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
